<div class="hpanel gs-widget-cardmargin-bottom-5">
  <div class="panel-heading gs-widget-headerhbuilt wig-c">
    {{ headerTitle }}
  </div>
  <div class="panel-body gs-widget-bodypadding-top-6 padding-bottom-0">
    <div class="row">
      <div class="col-lg-12">
        <ul class="profile-list">
          <ng-container *ngFor="let item of user | slice:0:3; let i=index">
            <app-common-profile-info [type]="'COMMUNITY'">
              <ng-container headline1>Mavens-i softech solution pvt.ltd</ng-container>
              <ng-container headline2>32,345 Followers</ng-container>
              <ng-container btn><button class="btn-primary btn btn-xs">
                <!-- <ng-icon name="tablerPlus"></ng-icon> -->
                 Join
              </button></ng-container>
            </app-common-profile-info>
          </ng-container>
        </ul>
        <!-- <p style="float: right;" *ngIf="user.length > 3"z>
          <u><a >...More</a></u>
        </p> -->

        
        <button class="gs-743-more-btn" type="button" *ngIf="user.length > 0">
          View more →
        </button>
      </div>
    </div>
  </div>
</div>
